import React from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import useDictionary from '@ui/hooks/useDictionary';
import { IProps } from './IProps';
import { colors } from './colors.enum';
import { brandConfig } from '@config/brand.config';

const Component: React.FC<IProps> = ({
    color,
    disabled,
    label,
    onKeyDown,
    onClick,
}: IProps) => {
    const getWord = useDictionary();

    let _color: ButtonProps['color'] = 'primary';
    let _className = 'button';
    switch (color) {
        case colors.error:
            _color = 'error';
            break;
        case colors.warning:
            _color = 'warning';
            break;
        case colors.primaryAuth:
            _className = 'button_auth';
            break;
        case colors.demo:
            _className = 'button_demo';
            break;
        case colors.cookies:
            _className = 'button_cookies';
            break;
    }

    return (
        <Button
            className={_className}
            variant="contained"
            disabled={disabled}
            color={_color}
            style={
                brandConfig.buttonBackground
                    ? { background: brandConfig.buttonBackground }
                    : undefined
            }
            onClick={onClick}
            onKeyDown={onKeyDown}
        >
            {getWord(label)}
        </Button>
    );
};

const ButtonComponent = React.memo(Component);

export default ButtonComponent;
